import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86f40df4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "info block-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-tit" }, "申报详情", -1))
const _hoisted_4 = { class: "block-con" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "submit-btn"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "submit-btn"
}

import { flowsItem, staffItem, projectItem, approveStaff, Approve } from '@/apis/base'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const type_name = ref('')
const terminationDetails = ref({
  explain: '', // 说明
  approve_state: 0, // 审批流程
  pics: null, // 图片
  type_id: 0, // 项目类型
  item_id: 0, // 详情id
  tabsActive: 0, // 已发起
  approve: {} as Approve,
  project: {} as projectItem,
  flows: Array<flowsItem>()
})
const showBottom = ref(false)
const StaffInfo = ref({
  id: 0,
  name: '',
  avatar: ''
})
onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  terminationDetails.value = JSON.parse(router.currentRoute.value.query.data.toString())
  type_name.value = router.currentRoute.value.query.type_name.toString()
  let botton: any = router.currentRoute.value.query.button
  showBottom.value = botton
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_DetailTitle = _resolveComponent("DetailTitle")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_ApprovalProcess = _resolveComponent("ApprovalProcess")!
  const _component_BottomButtonTwo = _resolveComponent("BottomButtonTwo")!
  const _component_BottomButtonOne = _resolveComponent("BottomButtonOne")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_DetailTitle, {
      approve: terminationDetails.value.approve
    }, null, 8, ["approve"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_cell_group, {
          title: "项目名称",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: terminationDetails.value.project.name
            }, null, 8, ["title"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, {
          title: "终止原因",
          border: false,
          class: "mx-box"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              size: "large",
              type: "textarea",
              rows: "5",
              value: terminationDetails.value.explain
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_ApprovalProcess, {
      flows: terminationDetails.value.flows
    }, null, 8, ["flows"]),
    (terminationDetails.value.tabsActive == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (terminationDetails.value.approve.approve_staff?.id === StaffInfo.value.id && terminationDetails.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonTwo, {
                      key: 0,
                      typeId: terminationDetails.value.type_id,
                      itemId: terminationDetails.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (terminationDetails.value.tabsActive == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (terminationDetails.value.approve.staff_id=== StaffInfo.value.id && terminationDetails.value.approve.state == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (showBottom.value)
                  ? (_openBlock(), _createBlock(_component_BottomButtonOne, {
                      key: 0,
                      typeId: terminationDetails.value.type_id,
                      itemId: terminationDetails.value.item_id
                    }, null, 8, ["typeId", "itemId"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})